import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 3C0 1.34315 1.34315 0 3 0H21C22.6569 0 24 1.34315 24 3V21C24 22.6569 22.6569 24 21 24H3C1.34315 24 0 22.6569 0 21V3Z"
      fill="#FFB743"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.3333 16.0001V9.33341H6.66665V16.0001H17.3333ZM6.66665 6.66675H17.3333C17.6869 6.66675 18.0261 6.80722 18.2761 7.05727C18.5262 7.30732 18.6666 7.64646 18.6666 8.00008V16.0001C18.6666 16.3537 18.5262 16.6928 18.2761 16.9429C18.0261 17.1929 17.6869 17.3334 17.3333 17.3334H6.66665C6.31302 17.3334 5.97389 17.1929 5.72384 16.9429C5.47379 16.6928 5.33331 16.3537 5.33331 16.0001V8.00008C5.33331 7.64646 5.47379 7.30732 5.72384 7.05727C5.97389 6.80722 6.31302 6.66675 6.66665 6.66675Z"
      fill="white"
    />
  </svg>
);
const SvgDemoIndicatorColored = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgDemoIndicatorColored;
